import './plugins/mmenu.js';

// mmenu configuration for mobile nav
Mmenu.configs.offCanvas.page.selector = "#shell";

document.addEventListener(
    "DOMContentLoaded", () => {
        const menu = new Mmenu( "#mobile-menu", {
            "slidingSubmenus": true
        });
        const api = menu.API;
    }
);